import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { selectIsLoggedIn, VpnSetting, selectIsOwner, selectIsAdmin } from '@cloud/shared';

import { NavigationLink } from '@ovpn-ui/navigation';

import { getSettingBulk } from '../../api';
import { useMountGuard } from '../../hooks';

import { makeOwnerLinks, userLinks } from './utils';

function useMenuLinks(): NavigationLink[] {
    const isLoggedIn = useSelector(selectIsLoggedIn);
    const isOwner = useSelector(selectIsOwner);
    const isAdmin = useSelector(selectIsAdmin);
    const [settings, setSettings] = useState<any /* FixMe */>({});

    useEffect(() => {
        if (isLoggedIn && (isOwner || isAdmin)) {
            getSettingBulk([VpnSetting.EnableAuditLog, VpnSetting.EnableDomainResolutions])
                .then(t => {
                    setSettings(t);

                    setTimeout(() => {
                        document.body.classList.add('sidebar-loaded');
                    }, 50);
                })
                .catch(() => {
                    // eslint-disable-next-line no-console
                    console.warn('Failed to load sidebar configuration');
                });
        }
    }, [isAdmin, isOwner, isLoggedIn]);

    useMountGuard({
        mfName: '@cloud/dr',
        mfEnabled: settings[VpnSetting.EnableDomainResolutions] ?? null,
    });

    useMountGuard({
        mfName: '@cloud/audit-log',
        mfEnabled: settings[VpnSetting.EnableAuditLog] ?? null,
    });

    const links = useMemo((): NavigationLink[] => {
        if (isAdmin || isOwner) {
            return makeOwnerLinks({ isAdmin, settings });
        }

        return userLinks;
    }, [isAdmin, isOwner, settings]);

    return links;
}

export default useMenuLinks;
